module.exports = __webpack_public_path__ + "static/media/file_csv_solid.1fb18c09.svg";